import styled from '@emotion/styled';
import { motion, useReducedMotion } from 'framer-motion';

/** 칩이 늘어나거나 들고 날 때 공통으로 쓰는 전환 — 짧고 감속만 */
const CHIP_TRANSITION = { duration: 0.18, ease: 'easeOut' } as const;
const NO_TRANSITION = { duration: 0 } as const;

/**
 * 칩 전환 설정. 폭만 애니메이션한다 — framer-motion 의 layout 은 transform(scale) 기반이라
 * 명시적 width 전환과 겹치면 전환 중 글자가 눌려 보인다.
 * OS 에서 동작 줄이기를 켠 사용자에게는 전환 없이 즉시 반영한다.
 */
export const useChipMotion = () => {
  const transition = useReducedMotion() ? NO_TRANSITION : CHIP_TRANSITION;

  return {
    transition,
    /** 칩 하나 또는 칩 안 선택값이 들고 날 때 쓰는 motion props */
    slotMotion: {
      initial: { opacity: 0, width: 0 },
      animate: { opacity: 1, width: 'auto' },
      exit: { opacity: 0, width: 0 },
      transition,
    },
  };
};

/** 선택값 묶음이 들고 나는 자리. 폭 전환 중 내용이 삐져나오지 않게 잘라둔다 */
export const SummarySlot = styled(motion.span)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  white-space: nowrap;
`;

/** 칩 하나가 들고 나는 자리 — 폭이 0에서 늘어나며 자연스럽게 자리를 만든다 */
export const ChipSlot = styled(motion.div)`
  display: inline-flex;
  flex-shrink: 0;
  overflow: hidden;
`;
